import { Flex } from '@hover/blueprint';
import React from 'react';

import { CircleButton } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/ProductSearch/FilterSelector/CircleButton';

export type IconButtonCheckListItem = {
  id: string;
  dataTestId: string;
  label: string;
  name: string;
  isChecked: boolean;
  imgSrc?: string;
  color?: string;
};

export type IconButtonCheckListParams = {
  items: IconButtonCheckListItem[];
  onSelectedIdsChanged: (selectedIds: string[]) => void;
  testId: string;
};

export const IconButtonCheckList = ({
  items,
  onSelectedIdsChanged,
  testId,
}: IconButtonCheckListParams) => {
  const onItemClicked = (newItems: IconButtonCheckListItem[]) => {
    onSelectedIdsChanged(
      newItems.filter(item => item.isChecked).map(item => item.id),
    );
  };

  return (
    <Flex data-testid={testId} direction="row" flexWrap="wrap" gap="16px">
      {items.map((item, index) => (
        <CircleButton
          buttonSize="60px"
          dataTestId={item.dataTestId}
          imgSrc={item.imgSrc}
          isSelected={item.isChecked}
          key={item.id}
          label={item.label}
          onClick={() => {
            const newSelection = [...items];
            newSelection[index].isChecked = !newSelection[index].isChecked;
            onItemClicked(newSelection);
          }}
          outlineOffset="3px"
          text={item.name}
          {...(item.color ? { color: item.color } : {})}
        />
      ))}
    </Flex>
  );
};
